export const ShipmentMessageType = {
    WAYBILL_PRINT_MESSAGE: 'waybillPrintHandler'
}

export const ShipmentMessageSeverity = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
}